import { ApiEndpoints, Constants } from "../../constants/appConstants"
import { useAuthContext } from "../../Context/AuthContext"
import httpService from "../../services/httpService"
import MultipartFileUploadComponent from "../FileUpload/MultpartFileUploadComponent"
import { ProviderFileInfoComponent } from "../ProviderFileInfo"
import { useEffect, useState } from "react"
import { useAppContext } from "../../Context"

interface DataUploadComponentProps {
    providerType?: string;
    reviewYear?: number;
    onChangeProviderType? : (value: string) => void;
}

export const DataUploadComponent = ({ providerType: propProviderType, reviewYear: propReviewYear,onChangeProviderType }: DataUploadComponentProps = {})=>{
    // const [IsActiveReview,setIsActiveReview] = useState(false);
    const [refresh,setRefresh] = useState(false);
    const{providerType: contextProviderType, reviewYear: contextReviewYear} =useAppContext();
    const providerType = propProviderType ?? contextProviderType;
    const reviewYear = propReviewYear ?? contextReviewYear;
    const {isAdministrator} = useAuthContext();
    const [isDucLocked,setIsDucLocked] = useState(true);
    useEffect(()=>{
        if(providerType){
        // isActiveReviewCycle();
        getLibraryLockFeature();
        }
    },[providerType])

    // const isActiveReviewCycle = () => {
    //     httpService
    //         .get(`${ApiEndpoints.IsActiveReview}/${providerType}`)//add dynamic provider type
    //         .then((response: any) => {
    //             setIsActiveReview(response?.data);
    //         })
    //         .catch((error: any) => {
    //             console.log("Error: ", error);
    //         });
    // };

    const getLibraryLockFeature = () => {
    httpService
      .get(`${ApiEndpoints.GetProviderFeature}/${providerType}/${Constants.DATA_UPLOAD_CENTER_LOCKED}`)
      .then((response: any) => {
        if(response.status === 200){
            setIsDucLocked(!response?.data.isEnabled);
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
  };

    const onFileuploaded = ()=>{
        setRefresh(!refresh);
    };
    return <>
            { isAdministrator() && <div style={{display:"flex",flexDirection:"row",justifyContent:"space-evenly"}} className="card">
                <MultipartFileUploadComponent className="p-mb-3" isBulkUpload={true} isDucLocked={isDucLocked} providerType={providerType} setProviderType={onChangeProviderType} onFileuploaded={onFileuploaded} allowedExtension=".csv,.xls,.xlsx" reviewYear={reviewYear}></MultipartFileUploadComponent>
            </div>}
        <ProviderFileInfoComponent showBulkData={true} isDucLocked={isDucLocked} isFileUploaded={refresh} reviewYear={reviewYear}></ProviderFileInfoComponent>            
    </>
}